import { c as _c } from "react/compiler-runtime";
import { Control, Controller, FieldPath, FieldValues, PathValue, UseFormSetValue } from 'react-hook-form';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useCourseThemes from '../hooks/use-course-themes';
import CourseThemeSelectItem from './course-theme-select-item';
type CourseThemeSelectProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = {
  control: Control<TValues>;
  setValue: UseFormSetValue<TValues>;
  name?: TName;
};
const CourseThemeSelect = t0 => {
  const $ = _c(8);
  const {
    setValue,
    control,
    name
  } = t0;
  useLocoTranslation();
  const {
    themes
  } = useCourseThemes();
  const selectName = name || "theme" as TName;
  let t1;
  if ($[0] !== selectName || $[1] !== setValue || $[2] !== themes) {
    t1 = t2 => {
      const {
        field: t3
      } = t2;
      const {
        value
      } = t3;
      return <div className="customScroll grid max-h-[200px] gap-3 overflow-y-auto md:max-h-[350px] md:grid-cols-2" role="radiogroup" data-test-id="course-theme-select">{themes?.map(theme => <CourseThemeSelectItem key={`course-theme-${theme.id}`} theme={theme.colorSet} selected={value === theme.id} id={theme.id} onChange={id => setValue(selectName, id as PathValue<TValues, TName>)} />)}</div>;
    };
    $[0] = selectName;
    $[1] = setValue;
    $[2] = themes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== control || $[5] !== selectName || $[6] !== t1) {
    t2 = <Controller name={selectName} control={control} render={t1} />;
    $[4] = control;
    $[5] = selectName;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default CourseThemeSelect;